export default __webpack_public_path__ + "static/media/image.greasesmonkey-lk.4dfa9513.png";